// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});


//FAQ
$(document).ready(function () {
    if ($('.faq-question').length) {
        getFolding();
    }

    if ($('.product-images-container').length) {
        handleProductGalleries();
    }

    // Change Recaptcha error message
    if ($('.field.nocaptcha .message.error').length || $('.controller-form .message.error').length) {
        changeErrMsg();
    }
});

function changeErrMsg() {
    let targetCaptchaParent = $('.nocaptcha')
    let targetFormParent = $('.controller-form');

    if (targetCaptchaParent.children('.message.error').length) {
        let target = targetCaptchaParent.children('.message.error');
        target.text('Verification failed. Please try to verify again.');
    }

    if (targetFormParent.children('.message.error').length && targetFormParent.children('.message.error').text() === 'Please answer the captcha, if you do not see the captcha please enable JavaScript') {
        let target = targetFormParent.children('.message.error');
        target.text('Verification failed. Please try to verify again.');
    }
}

function handleProductGalleries() {
    $('.product-images-container').each(function () {
        let $targetCog = $(this).parent();

        let $mainGlide = new Glide(".main-gallery-container.glide", {
            type: "carousel",
            dragThreshold: false,
            perView: 1,
        });

        let $secondaryGlide = new Glide(".secondary-gallery-container.glide", {
            type: "carousel",
            perView: 4,
            dragThreshold: false,
            gap: 5,
            breakpoints: {
                1512: {
                    perView: 3
                },
                992: {
                    perView: 4
                },
                680: {
                    perView: 2,
                    gap: 50,
                },
            }
        });

        // Synchronize the galleries
        $mainGlide.on('run.after', () => {
            $secondaryGlide.go(`=${$mainGlide.index}`);
        });

        $secondaryGlide.on('run.after', () => {
            $mainGlide.go(`=${$secondaryGlide.index}`);
        });

        // Mount both instances

        window.setTimeout(function () {
            $mainGlide.mount();
            $secondaryGlide.mount();
        }, 1000)

        window.setTimeout(function () {
            $mainGlide.update();
            $secondaryGlide.update();

            if ($targetCog.hasClass('inactive')) {
                $targetCog.removeClass('inactive');
            }
        }, 1250)

        let $target = $(this).find('.glide__arrows');

        $target.children('.glide__arrow').each(function () {
            $(this).on('click', function () {
                let $currentPos = parseInt($target.find('.current').text());

                if ($(this).hasClass('glide__arrow--left')) {
                    $currentPos -= 1;
                } else {
                    $currentPos += 1;
                }

                if ($currentPos === 0) {
                    $currentPos = parseInt($target.find('.total').text());
                } else if ($currentPos > parseInt($target.find('.total').text())) {
                    $currentPos = 1;
                }

                $target.find('.current').text($currentPos);
            });
        });
    });
}

function getFolding() {
    const $Questions = $('.faq-item');

    $Questions.each(function () {
        $(this).removeClass('unfold');
        $(this).children('.faq-answer').hide();
    });


    $Questions.on('click', function () {
        $(this).siblings('.unfold').trigger('click')

        let $Answer = $(this).children('.faq-answer');
        $(this).toggleClass('unfold')

        if ($(this).hasClass('unfold')) {
            $Answer.show()
            let height = $Answer.height()
            $Answer.height(0).height(height)
            window.setTimeout(function () {
                $Answer.height('')
            }, 250)
        } else {
            let height = $Answer.height()
            $Answer.height(height).height(0)
            window.setTimeout(function () {
                $Answer.hide().height('')
            }, 250)
        }
    });
}

function updateQuantity(n) {
    let input = $('#AddProductForm_Form_Quantity');
    let val = parseInt(input.val());
    n = parseInt(n);
    if(!isNaN(val) && val >= 0) {
        if(n == -1 && val == 0) return;
        input.val(parseInt(val) + parseInt(n));
    }
}

